export default "__VITE_ASSET__CwMhg7N3__"